export default {
    okx_address(){
        // return 'https://www.dflepam.cn/join/UPLUS2'
        // return 'https://www.sdchizhengjixie.com/join/UPLUS2'
        // return 'https://www.ouyicn.press/join/10523149'
        // return 'https://www.cnouyi.care/join/UPLUS3'
        // return 'https://www.tianyena.com/join/UPLUS3'
        return 'https://www.ouxyi.io/ul/6CngT5?channelId=UPLUS3'
    },
    binance_address(){
        return 'https://accounts.marketwebb.net/register?ref=37664683'
    },

    gate_address(){
        return 'https://www.gatenode.xyz/signup/BlgXUFhY?ref_type=103'
    },

    bybit_address(){
        return 'https://partner.bybit.com/b/123512'
    },

    download_android_address(){
        return 'https://ndzln.lahuafa.com/fbEfXM3NG/88L408quyrX9XYGi'
    },

    download_ios_h5_address(){
        return 'https://wcth0210.l88dtgp.top:19582/webclip/single/a9430954'
    },

    download_ios_beta_address(){
        return 'https://testflight.apple.com/join/z5P0yjyt'
    },

    download_ios_p_address(){
        return 'https://ngyzz.jjmh22.com/tq5kRENW7/14rF3Y6USDl2CSzxe'
    },

    download_ios_address(){
        // return 'https://u.ppx6.com/5aad59'
        return 'https://fyoss.fy5.co/d7mt2d'
    },

    host_uri() {
        return 'ai.uplustrade.com'
        // return 'localhost'
    }
}
